var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 13.6666H6.33333M9 19H6.33333M17 8.33329H6.33333M22.3333 13V8.06663C22.3333 5.82641 22.3333 4.70631 21.8973 3.85067C21.5139 3.09801 20.902 2.48609 20.1493 2.1026C19.2936 1.66663 18.1736 1.66663 15.9333 1.66663H7.4C5.15979 1.66663 4.03968 1.66663 3.18404 2.1026C2.43139 2.48609 1.81947 3.09801 1.43597 3.85067C1 4.70631 1 5.82641 1 8.06663V21.9333C1 24.1736 1 25.2936 1.43597 26.1493C1.81947 26.902 2.43139 27.5138 3.18404 27.8973C4.03968 28.3333 5.15979 28.3333 7.4 28.3333H11M25 28.3333L23 26.3333M24.3333 23C24.3333 25.5773 22.244 27.6666 19.6667 27.6666C17.0893 27.6666 15 25.5773 15 23C15 20.4226 17.0893 18.3333 19.6667 18.3333C22.244 18.3333 24.3333 20.4226 24.3333 23Z",
    stroke: "#043F6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocSearch);
export default __webpack_public_path__ + "static/media/ic-doc-search.652bfd93c90f0717b636eeae14d6728d.svg";
export { ForwardRef as ReactComponent };